// @flow
import React, { Component } from 'react';
import Modal from 'react-modal';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';
import type { RouterHistory } from 'react-router-dom';

import localizedStrings from 'util/localizedStrings';
import LoginForm from './LoginForm';
import { openHelpLink } from 'util/browserUtils';

type Props = {
  history: RouterHistory,
  intl: IntlShape,
  isFullAdmin: boolean,
  showAbout: () => void,
};

class LoginModal extends Component<Props> {
  closeModal: Function;
  openHelpLink: Function;

  constructor() {
    super();
    this.closeModal = this.closeModal.bind(this);
    this.openHelpLink = this.openHelpLink.bind(this);
  }

  closeModal() {
    const { history, isFullAdmin } = this.props;
    history.push(isFullAdmin ? '/status' : '/catalogs');
  }

  openHelpLink() {
    openHelpLink(this.props.intl);
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const modalStyles = {
      overlay: {
        backgroundColor: 'rgba(127, 127, 127, 0.9)',
      },
      content: {
        padding: '0px',
        width: '100%',
        height: '100%',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        overflow: 'hidden',
      },
    };

    return (
      <Modal style={modalStyles} contentLabel="Login Modal" isOpen={true}>
        <div className="splashScreen">
          <div className="helpAboutLinkContainer">
            <span className="upperRightLink">
              <a className="helpLink" onClick={this.openHelpLink}>
                {formatMessage(localizedStrings.NAV_HELP)}
              </a>
            </span>
            <span>//</span>
            <span className="upperRightLink">
              <a className="helpLink" onClick={this.props.showAbout}>
                {formatMessage(localizedStrings.ABOUT)}
              </a>
            </span>
          </div>

          <div className="loginWrapper">
            <LoginForm closeModal={this.closeModal} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default (LoginModal = withRouter(injectIntl(LoginModal)));



// WEBPACK FOOTER //
// ./src/view/App/Login/LoginModal.js